import { DialogContent } from './ui/DialogContent';
import React, { useState } from 'react';
import { Typography, TextField, Button } from '@mui/material';
import { ResponsiveDialog } from './ui/ResponsiveDialog';
import { DialogHeader } from './ui/DialogHeader';
import { DialogActions } from './ui/DialogActions';
import { useUnsavedChangesGuard } from '../hooks/useUnsavedChangesGuard';

interface BulkKeywordsModalProps {
  scopeKey?: string;
  open: boolean;
  onClose: () => void;
  onConfirm: (keywords: string) => void;
}

const BulkKeywordsModal: React.FC<BulkKeywordsModalProps> = ({
  scopeKey,
  open,
  onClose,
  onConfirm,
}) => {
  const [keywords, setKeywords] = useState('');
  const discard = () => setKeywords('');
  const { requestClose, runAfterSave } = useUnsavedChangesGuard({
    scopeKey,
    open,
    dirty: keywords !== '',
    onDiscard: discard,
    onClose,
  });
  const close = () => {
    void requestClose();
  };

  const handleSubmit = () => {
    if (keywords.trim()) {
      runAfterSave(() => onConfirm(keywords.trim()));
      setKeywords('');
    }
  };

  return (
    <ResponsiveDialog
      open={open}
      onClose={close}
      aria-labelledby="bulk-keywords-title"
    >
      <DialogHeader
        id="bulk-keywords-title"
        title="Append Keywords"
        onClose={close}
      />
      <DialogContent sx={{ display: 'grid', gap: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Enter keywords to append to all selected items
        </Typography>
        <TextField
          fullWidth
          multiline
          value={keywords}
          onChange={(e) => setKeywords(e.target.value)}
          placeholder="Enter keywords..."
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!keywords.trim()}
        >
          Append
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  );
};

export default BulkKeywordsModal;
